const BANNER_DATA = [
  {
    id: "1",
    imageUrl:
      "https://cdn.pixabay.com/photo/2016/01/27/22/10/shopping-1165437_1280.jpg",
    title: " Welcome To My Brand Online Super Shop",
    description:
      "We promise to make things easier, faster and comfortable for you.",
  },
];

export default BANNER_DATA;
